// extracted by mini-css-extract-plugin
export default {"headerRow":"SimpleTabs_headerRow__yVwC2","customNavTabs":"SimpleTabs_customNavTabs__mY88K"};